import React, { FC } from 'react';
import Button from '@mui/material/Button';

import { useTimesheetEdit } from 'src/features/timesheets/providers';
import { CopyIcon } from 'src/shared/components';
import { useTranslate } from 'src/shared/providers';

export const TimesheetCopyLastWeek: FC = () => {
  const { t } = useTranslate();

  const { onCopyLastWeek, loading, initialTimesheet } = useTimesheetEdit();

  const canCopyLastWeek = initialTimesheet?.canCopyLastWeek;

  return (
    <Button
      color="secondary"
      startIcon={<CopyIcon size={20} />}
      disabled={loading || !canCopyLastWeek}
      onClick={onCopyLastWeek}
    >
      {t('timesheets.copyLastWeek')}
    </Button>
  );
};
